import { runClientComponent } from '../../_common/client/client-component-runner';
import { ImageGalleryComponent } from './image-gallery.component';

import '../../_feature-components/zoom-image';

runClientComponent({ ImageGalleryComponent });
